<template>
  <router-link
    :to="to"
    class="group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors"
    :class="linkClasses"
    @click="handleClick"
  >
    <component
      :is="icon"
      class="mr-3 h-5 w-5 flex-shrink-0"
      :class="iconClasses"
    />
    {{ name }}
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Component } from 'vue'

// Props
interface Props {
  to: string
  icon: Component
  name: string
  isActive: boolean
}

const props = defineProps<Props>()

// Emits
interface Emits {
  (e: 'click'): void
}

const emit = defineEmits<Emits>()

// Computed
const linkClasses = computed(() => {
  return props.isActive
    ? 'bg-blue-100 text-blue-700'
    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
})

const iconClasses = computed(() => {
  return props.isActive
    ? 'text-blue-500'
    : 'text-gray-400 group-hover:text-gray-500'
})

// Methods
const handleClick = () => {
  emit('click')
}
</script> 